/* HYLEVELGEAR — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function formatMoney(cents) {
    var fmt = (window.hlMoneyFormat || '{{amount_with_comma_separator}} €');
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var intDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var intComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, intDot + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, intDot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, intComma)
      .replace(/\{\{\s*amount\s*\}\}/, intComma + '.' + parts[1]);
  }

  /* ---------- Reveal + cifras ---------- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    var dec = (el.getAttribute('data-count').split('.')[1] || '').length;
    if (reduce) { el.textContent = target.toFixed(dec); return; }
    var start = null, dur = 1600;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toFixed(dec);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.hl-reveal:not(.hl-visible), [data-count]:not([data-counted])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) {
        el.classList.add('hl-visible');
        if (el.hasAttribute('data-count')) { el.setAttribute('data-counted', '1'); countUp(el); }
      });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          el.classList.add('hl-visible');
          if (el.hasAttribute('data-count') && !el.hasAttribute('data-counted')) {
            el.setAttribute('data-counted', '1');
            countUp(el);
          }
          io.unobserve(el);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax del hero ---------- */
  function initParallax() {
    if (reduce) return;
    var imgs = document.querySelectorAll('[data-hl-parallax]');
    if (!imgs.length) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var k = parseFloat(img.getAttribute('data-hl-parallax')) || 0;
        var rect = img.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (-rect.top * k / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Sensores: punto <-> lista ---------- */
  function initHotspots() {
    document.querySelectorAll('[data-hl-sensors]').forEach(function (wrap) {
      var spots = wrap.querySelectorAll('.hl-hotspot');
      var items = wrap.querySelectorAll('.hl-feature');
      function activate(i) {
        items.forEach(function (it, j) { it.classList.toggle('is-active', i === j); });
      }
      spots.forEach(function (s, i) {
        s.addEventListener('mouseenter', function () { activate(i); });
        s.addEventListener('click', function () {
          activate(i);
          if (items[i] && window.innerWidth < 990) items[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      items.forEach(function (it, i) { it.addEventListener('mouseenter', function () { activate(i); }); });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProduct() {
    document.querySelectorAll('[data-hl-pdp]').forEach(function (root) {
      var dataEl = root.querySelector('[data-hl-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = root.querySelector('form.hl-form');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var btn = root.querySelector('[data-hl-add]');
      var btnLabel = btn ? btn.querySelector('span') : null;
      var priceNow = root.querySelector('[data-hl-price]');
      var priceWas = root.querySelector('[data-hl-compare]');
      var save = root.querySelector('[data-hl-save]');
      var stickyPrice = document.querySelector('[data-hl-sticky-price]');
      var errorEl = root.querySelector('[data-hl-error]');
      var mainImg = root.querySelector('[data-hl-main]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('.hl-gallery__thumb'));
      var current = 0;

      /* Galería */
      function show(i) {
        if (!thumbs.length || !mainImg) return;
        current = (i + thumbs.length) % thumbs.length;
        var t = thumbs[current];
        var vWrap = root.querySelector('[data-hl-video]');
        if (vWrap) {
          var vEl = vWrap.querySelector('video');
          var isVid = t.hasAttribute('data-video');
          vWrap.hidden = !isVid;
          if (vEl) { if (isVid) { vEl.play && vEl.play().catch(function () {}); } else { vEl.pause && vEl.pause(); } }
          if (isVid) {
            thumbs.forEach(function (x, j) { x.classList.toggle('is-active', j === current); });
            return;
          }
        }
        mainImg.style.opacity = '0.2';
        var src = t.getAttribute('data-src');
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          mainImg.src = src;
          mainImg.removeAttribute('srcset');
          mainImg.alt = t.getAttribute('data-alt') || '';
          mainImg.style.opacity = '1';
        };
        pre.src = src;
        thumbs.forEach(function (x, j) { x.classList.toggle('is-active', j === current); });
        t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = root.querySelector('[data-hl-prev]');
      var next = root.querySelector('[data-hl-next]');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });

      /* Variantes */
      var fieldsets = root.querySelectorAll('[data-hl-option]');
      var initial = true;
      /* Ordena de menor a mayor las opciones numéricas (tallas) */
      fieldsets.forEach(function (fs) {
        var box = fs.querySelector('.hl-opt__vals');
        var inputs = Array.prototype.slice.call(box.querySelectorAll('input'));
        if (!inputs.length || !inputs.every(function (i) { return !isNaN(parseFloat(i.value)); })) return;
        inputs.sort(function (a, b) { return parseFloat(a.value) - parseFloat(b.value); }).forEach(function (i) {
          var l = box.querySelector('label[for="' + i.id + '"]');
          box.appendChild(i); if (l) box.appendChild(l);
        });
      });
      function selected() {
        var vals = [];
        fieldsets.forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          vals.push(c ? c.value : null);
          var lbl = fs.querySelector('[data-hl-option-value]');
          if (lbl && c) lbl.textContent = c.value;
        });
        return vals;
      }
      function update() {
        if (!fieldsets.length) return;
        var vals = selected();
        var matches = variants.filter(function (x) {
          return x.options.every(function (o, i) { return o === vals[i]; });
        });
        var v = matches.find(function (x) { return x.available; }) || matches[0];
        /* marcar combinaciones no disponibles */
        fieldsets.forEach(function (fs, idx) {
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = vals.slice(); test[idx] = inp.value;
            var ok = variants.some(function (x) {
              return x.available && x.options.every(function (o, i) { return o === test[i]; });
            });
            var l = fs.querySelector('label[for="' + inp.id + '"]');
            if (l) l.classList.toggle('is-unavailable', !ok);
          });
        });
        if (!v) {
          if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = btn.getAttribute('data-unavailable'); }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = formatMoney(v.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
        if (priceWas) {
          var has = v.compare_at_price && v.compare_at_price > v.price;
          priceWas.textContent = has ? formatMoney(v.compare_at_price) : '';
          priceWas.hidden = !has;
          if (save) {
            save.hidden = !has;
            if (has) save.textContent = save.getAttribute('data-template').replace('[pct]', Math.round((1 - v.price / v.compare_at_price) * 100));
          }
        }
        if (btn) {
          btn.disabled = !v.available;
          if (btnLabel) btnLabel.textContent = v.available ? btn.getAttribute('data-add') : btn.getAttribute('data-soldout');
        }
        if (initial) { initial = false; return; }
        if (v.featured_media && thumbs.length) {
          var idx = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') == v.featured_media; });
          if (idx > -1) show(idx);
        }
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
      update();

      /* Cantidad */
      var qty = root.querySelector('[data-hl-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value, 10) || 1;
            n += b.getAttribute('data-step') === '+' ? 1 : -1;
            input.value = Math.max(1, n);
          });
        });
      }

      /* Añadir al carrito (abre el carrito lateral del tema) */
      if (form) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer');
          if (!window.fetch) return;
          e.preventDefault();
          if (errorEl) errorEl.textContent = '';
          btn.disabled = true;
          var fd = new FormData(form);
          if (drawer) {
            fd.append('sections', 'cart-drawer,cart-icon-bubble');
            fd.append('sections_url', window.location.pathname);
          }
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', body: fd, headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
          }).then(function (r) { return r.json(); }).then(function (res) {
            btn.disabled = false;
            if (res.status) {
              if (errorEl) errorEl.textContent = res.description || res.message || 'Error';
              return;
            }
            if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          }).catch(function () {
            btn.disabled = false;
            form.submit();
          });
        });
      }

      /* Barra de compra fija (móvil y escritorio) */
      var sticky = document.querySelector('[data-hl-sticky]');
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('is-on', !e.isIntersecting);
        }).observe(btn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (!btn.disabled) setTimeout(function () { btn.click(); }, 450);
        });
      }
    });
  }

  function initAll() {
    initReveal();
    initParallax();
    initHotspots();
    initProduct();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Carrito: "Completa tu equipo" (añadir con un clic, delegado porque el carrito se re-renderiza) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hl-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-hl-upsell]');
    var sel = card && card.querySelector('select');
    var id = btn.getAttribute('data-variant') || (sel && sel.value);
    if (!id) return;
    var drawer = document.querySelector('cart-drawer');
    btn.disabled = true;
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) {
        btn.disabled = false;
        var err = document.querySelector('[data-hl-upsell-error]');
        if (err) err.textContent = res.description || res.message || 'No se pudo añadir';
        return;
      }
      if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
        res.id = id;
        drawer.renderContents(res);
      } else {
        window.location.reload();
      }
    }).catch(function () { btn.disabled = false; });
  });

  /* Selector de pack (1 ud / pack): fija la cantidad del formulario */
  document.addEventListener('change', function (e) {
    if (e.target.name !== 'hl-pack') return;
    var q = e.target.form && e.target.form.querySelector('input[name="quantity"]');
    if (q) q.value = e.target.value;
  });

  /* Judge.me: nombres de reseñas importadas solo con iniciales ("D. M.") */
  function initialsReviewers(root) {
    (root || document).querySelectorAll('.jm-reviewer-info__name, .jdgm-rev__author').forEach(function (el) {
      if (el.dataset.hlInit) return;
      var parts = el.textContent.trim().split(/[\s.]+/).filter(Boolean);
      if (!parts.length) return;
      el.textContent = parts.map(function (p) { return p.charAt(0).toUpperCase() + '.'; }).join(' ');
      el.dataset.hlInit = '1';
    });
  }
  initialsReviewers();
  new MutationObserver(function () { initialsReviewers(); }).observe(document.body, { childList: true, subtree: true });

  /* Editor de Shopify: re-inicializa al añadir/cambiar secciones */
  document.addEventListener('shopify:section:load', function () { initReveal(); initHotspots(); });
})();
